// Types do not increase the bundle size, do not import anything that will increase bundle size as this is used in bootstrap script
import { TrackingConsents } from './types';

export const generateTrackingConsents = (enabled: boolean): TrackingConsents => ({
    advertising: enabled,
    functional: enabled,
    necessary: enabled,
    performance: enabled,
});
